module.exports = __webpack_public_path__ + "img/album02_07.8daca787.jpg";